<template>
  <div>
    <div class="cont">
      <div class="container">
        <div class="row con pt-5 pb-5 mb-5">
          <div class="col-12">
            <h2>
              <span></span> <img src="../assets/Vector (1).png" />Want to work
              on a project with me?
            </h2>
            <P
              >You can send a mail
              <span class="nan">@nancee801@gmail.com</span> or reach out through
              my social handles below.</P
            >
            <p>
              <span
                ><a
                  href="https://www.linkedin.com/in/chidinma-okwuoha-034336179/"
                >
                  <img
                    alt="Qries"
                    src="../assets/Frame 9 (1).png"
                    width="50px"
                    height="50px"
                  /> </a
              ></span>
              <span class="ml-4 mr-4 er">
                <a href="https://twitter.com/ChidinmaOkwuoh1">
                  <img
                    alt="Qries"
                    src="../assets/Frame 10 (1).png"
                    width="50px"
                    height="50px"
                  /> </a
              ></span>
              <span class="ml-4 mr-4 er">
                <a href="https://secondproject2.netlify.app">
                  <img
                    alt="Qries"
                    src="../assets/Frame 11 (1).png"
                    width="50px"
                    height="50px"
                  /> </a></span
              ><span class="ml-4 mr-4 er">
                <a href="https://secondproject2.netlify.app">
                  <img
                    alt="Qries"
                    src="../assets/Frame 12 (1).png"
                    width="50px"
                    height="50px"
                  /> </a
              ></span>
            </p>
          </div>
        </div>
        <div class="row last text-center">
          <div class="col-12">
            Designed by <span class="nan">@designertemi.Developed by</span>
            <span class="nan">@Chidinma</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonFooter",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Petrona:wght@200;300&family=Space+Mono:ital@1&display=swap");
.cont {
  /*background-color: black !important;
  color: white;*/
  text-align: center;
}
.con {
  border-radius: 10px;
  border: 1px solid #15bf50;
}
.nan {
  color: #15bf50;
}
.last {
  margin-top: 120px;
  padding-bottom: 50px;
}
.er {
  margin-left: 50px !important;
  /* margin-right: 30px !important;*/
}
</style>